<template>
  <div>
    <div class="box" @click="close" v-if="this.$store.state.LoginShow">
      <div @click.stop="noDian" class="InterfaceBox">
        <div class="rightBox">
          <span class="close" @click="close">×</span>
          <!-- 登录 -->
          <div v-if="registerShow == 1">
            <div class="SignInBut">
              <!-- <p :class="Switch ? 'Highlight' : ''" @click="SwitchDeng">
                <span>短信登录</span>
              </p> -->
              <!-- <p :class="!Switch ? 'Highlight' : ''" @click="SwitchDeng" style="margin-right: 0"> -->
              <p class="Highlight" style="margin-right: 0">
                <span>账号登录</span>
              </p>
            </div>
            <!-- 登录 -->
            <div style="width: 78%;margin: 0 auto;">
              <!-- 短信登录 -->
              <div v-if="Switch">
                <div>
                  <p class="radiusBox phone flex">
                    <img src="@/assets/images/phone.png" style="width: .18rem;height:.18rem;"/>
                    <input
                      type="number"
                      placeholder="手机号"
                      v-model="phone"
                      @change="phoneFun1"
                    />
                  </p>
                  <p class="radiusBox Code flex">
                    <img src="@/assets/images/code.png" style="width: .18rem;height:.18rem;" />
                    <input
                      type="number"
                      placeholder="请输入验证码"
                      v-model="Code"
                    />
                    <button class="ccse" @click="obtainCode()" :disabled="isDisable">{{btnTitle}}</button>
                    <!-- <button @click="obtainCode">获取验证码</button> -->
                  </p>
                </div>
                <div class="dengLuBut">
                  <button @click="SignInCode" @keyup.enter="keyDown1(e)">登录</button>
                </div>
              </div>
              <!-- 账号密码登录 -->
              <div v-if="!Switch">
                <div style="position: relative;">
                  <p class="radiusBox phone flex">
                    <img src="@/assets/images/user.png" style="width: .18rem;height:.18rem;"/>
                    <input
                      type="text"
                      placeholder="请输入账号"
                      v-model="phone"
                    />
                  </p>
                  <p class="radiusBox phone flex" style="">
                    <img src="@/assets/images/pass.png" style="width: .18rem;height:.18rem;"/>
                    <input
                      type="password"
                      placeholder="请输入密码"
                      v-model="Code"
                      @input="passChange"
                    />
                  </p>
                  <!-- <div style="display: flex;align-items: center;margin-bottom:0" v-if="captchaEnabled">
                    <p class="radiusBox phone flex" style="width: 60%;">
                      <img src="@/assets/images/code.png" style="width: .18rem;height:.18rem;"/>
                      <input
                        type="text"
                        placeholder="请输入验证码"
                        v-model="codes"
                      />
                    </p>
                    <div class="login-code" style="padding-left: 5px;box-sizing: border-box;">
                      <img :src="codeUrl" @click="getCode" class="login-code-img" />
                    </div>
                  </div> -->
                  <div class="redTip" v-if="loginCode != 601 && loginCode">*{{message}}</div>
                  <div v-if="loginCode == 601" class="redTip">*请输入账号/密码</div>
                </div>
                <div class="flex" style="width:80%;margin-top: .2rem;">
                  <el-checkbox
                    v-model="rememberMe1"
                    style="transform: scale(0.8);"
                  ></el-checkbox>
                  <div style="padding-left: .04rem;">记住密码</div>
                  <!-- <div style="padding-left: 4px;color: rgba(0, 0, 0, 0.4);font-size:.12rem;">同意 《个人信息保护政策》《服务协议》登录过程中会用到短信，请注意您的手机提示，我们将保护您个人手机号信息。</div> -->
                </div>
                <div class="dengLuBut">
                  <button @click="SignIn"  @keyup.enter="keyDown(e)">登录</button>
                </div>
              </div>
              <!-- <div v-if="noAgreeShow" style="font-size: .12rem;color: red;padding-left: .6rem;">*请同意服务协议</div> -->
              <!-- 支付宝登录 -->
              <!-- 切换登录 -->
              <div class="SwitchBox" style="display:none;">
                <p @click="register2"> 微信/支付宝登录</p>
                <p>没有账号？<span @click="register">立即注册</span></p>
              </div>
            </div>
          </div>
          <!-- 注册 -->
          <div v-if="registerShow == 2">
            <div class="SignInBut">
              <p class="Highlight" @click="SwitchDeng" style="margin-right: 0">
                <span>注册</span>
              </p>
            </div>
            <div style="width: 78%;margin: 0 auto;">
              <!-- 短信注册 -->
              <div>
                <div>
                  <p class="radiusBox phone flex">
                    <img src="@/assets/images/user.png" style="width: .18rem;"/>
                    <input
                      type="text"
                      placeholder="请输入手机号或邮箱"
                      v-model="phone"
                      @blur="phoneFun"
                    />
                  </p>
                  <p class="radiusBox Code flex" style="margin-bottom:.1rem">
                    <img src="@/assets/images/code.png" style="width: .18rem;"/>
                    <input
                      type="number"
                      placeholder="请输入验证码"
                      v-model="Code"
                    />
                    <button class="ccse" @click="obtainCode()"
                    :disabled="isDisable">{{btnTitle}}</button>
                  </p>
                  <p class="radiusBox phone flex">
                    <img src="@/assets/images/pass.png" style="width: .18rem;height:.18rem;"/>
                    <input
                      type="password"
                      placeholder="请输入密码"
                      v-model="pass"
                      @blur="phoneFun"
                    />
                  </p>
                </div>
                <div class="dengLuBut">
                  <button @click="accounts" style="margin:.17rem 0 .12rem 0">
                    注册
                  </button>
                </div>
                <div class="flex" style="width:80%;margin: 0 auto;">
                  <el-checkbox
                    v-model="rememberMe"
                    style="transform: scale(0.8);"
                  ></el-checkbox>
                  <div style="padding-left: .04rem;color: rgba(0, 0, 0, 0.4);font-size:.12rem;">同意 《个人信息保护政策》《服务协议》登录过程中会用到短信，请注意您的手机提示，我们将保护您个人手机号信息。</div>
                </div>
              </div>
              <!-- 切换登录 -->
              <!-- <div class="SwitchBox" style="margin-bottom:0">
                <p>已有账号,<span @click="register1">立即登录</span></p>
              </div> -->
            </div>
          </div>
          <!-- 支付宝登录 -->
          <div v-if="registerShow==3">
            <div class="zhi">
						<div class="xian"></div>
						<div class="wordss">3秒快速登录，下载高清素材</div>
						<div class="xian"></div>
					</div>
					<div class="logins">
						<div class="logins-one" @click="weixindenglu()">
							<div class="log-one-top"><img style="width: 100%;height: 100%;" src="../../img/wx.png"></div>
							<div class="log-one-button">微信登录</div>
						</div>
						<div class="login-two" @click="zhifubaodenglu()">
							<div class="log-one-top"><img style="width: 100%;height: 100%;" src="../../img/zfb.png"></div>
							<div class="log-one-button">支付宝登录</div>
						</div>
					</div>
          <div class="SwitchBox">
                <p @click="register1"> 手机/邮箱登录</p>
                <p>没有账号？<span @click="register">立即注册</span></p>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { login, getInfo,getCodeImg,loginxcx } from '@/api/login'
  import { callbackify } from 'util';
  import Cookies from "js-cookie";
  import { getToken, setToken, removeToken } from '@/utils/auth'
  import { encrypt, decrypt } from "@/utils/jsencrypt";

  export default {
    components: {},
    props: {
      registerShow: {
        type: Number,
        default: 1
      },
    },
    data() {
      return {
        Switch: false,
        phone: "",
        Code: "",
        pass: "",
        loginShow: true,
        zfblogin:false,
        btnTitle: '获取验证码',
        isDisable: false,
        loginer: sessionStorage.getItem('loginer'),
        names:sessionStorage.getItem("namess"),
        rememberMe1: false,
        rememberMe: false,
        noAgreeShow: false,
        loginCode: '',
        codes:'',
        codeUrl:'',
        uuid:'',
        captchaEnabled:true,
        message:''
      };
    },
    created(){
      console.log(this.registerShow);
      let id = sessionStorage.getItem("id")
      if(!id) {
        this.zcbh = 2
      }
      this.getCode();
      this.getCookie()
    },
    methods: {
      close() {
        this.$store.commit("LoginFun", false);
      },
      noDian() {},
      hasBeen() {
        this.$message.error("此电话号码已被注册，请使用其他电话号码");
      },
      success() {
        this.$message({
          message: "注册成功",
          type: "success"
        });
      },
      // 支付宝登录
      zhifubaodenglu(){
        const data = {
          loginType:'alipay'
        }
        this.axios.post('/consumer/login', data).then((res)=>{
            window.location.href = res.data.result
        })
      },
      // 微信登录
      weixindenglu(){
        this.$message({
          message: '功能开发中，请等待...',
          type: 'warning'
        });
        return
        const data = {
          loginType:'weixin'
        }
        this.axios.post('/consumer/login', data).then((res) =>{
          console.log(res,33333333);
          window.location.href = res.data.result
        })
      },
      getCode() {
        getCodeImg().then((res) => {
          this.captchaEnabled = res.captchaEnabled === undefined ? true : res.captchaEnabled;
          if (this.captchaEnabled) {
            this.codeUrl = "data:image/gif;base64," + res.img;
            this.uuid = res.uuid;
          }
        });
      },
      // 账号注册
      accounts() {
          if (!this.phone) {
            setTimeout(() => {
              this.phone = ''
            }, 2000)
          } else if (!/^1[345678]\d{9}$/.test(this.phone) && !
            /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.phone)) {
            setTimeout(() => {
              this.phone = ''
            }, 2000)
          } else {
            const data = {
              userAccount: this.phone,
              password: this.pass,
              loginType:"phoneOrMail",
              verificationCode: this.Code,
            }
          this.axios
            .post("/consumer/register", data)
            .then((res) =>{
              console.log(res.data.code, "注册");
              if(res.data.code == 'S200'){
              this.$message({
                  message: '注册成功',
                  type: 'success'
                });
                this.registerShow = 1
              }else{
                this.$message.error(res.data.msg)
              }
            })
        }
      },
      // 立即注册
      register() {
        this.registerShow = 2;
      },
      register1() {
        this.registerShow = 1;
      },
      register2() {
        this.registerShow = 3;
      },
      // 账号密码登录回车键
      keyDown(e) {
        // 回车则执行登录方法 enter键的ASCII是13
        if (e.keyCode == 13) {
          // this.$route.name === 'login'this.SignIn(); // 定义的登录方法
        }
      },
      keyDown1(e) {
        // 回车则执行登录方法 enter键的ASCII是13
        if (e.keyCode == 13) {
          this.SignInCode(); // 定义的登录方法
        }
      },
      // 账号密码登录
      SignIn() {
        if (!this.phone || this.Code == "") {
          //this.open2();
          this.loginCode = 601;
        }
        // else if(!this.rememberMe) {
        //   this.open5();
        // }
        else {
          if(this.rememberMe1){
            Cookies.set("phone",this.phone,{expires:30})
            Cookies.set("Codes",encrypt(this.Code),{expires:30})
            Cookies.set("rememberMe1",this.rememberMe1,{expires:30})
          }else{
            Cookies.remove("phone");
            Cookies.remove("Codes");
            Cookies.remove("rememberMe1");
          }
          const data = {
            username: this.phone,
            password: encrypt(this.Code),
            code:this.codes,
            uuid:this.uuid
            // loginType: 'phoneOrMail',
          }
          loginxcx(data).then(response => {
            if(response.code == 200) {
              this.$message({
                message:'登录成功',
                type:'success'
              })
              setToken(response.token)
              this.$emit('loginChange');
              this.$store.commit("LoginFun", false);
              this.codes = null
              this.loginCode = ''
              this.message = ''
            }else{
              this.loginCode = response.code;
              this.message = response.msg
            }
          });
          // this.axios .post('/consumer/login', data).then(res => {
          //   if(res.data.code == "S200"){
          //     this.$store.commit("LoginFun", false);
          //     this.$message({
          //       message: "登录成功",
          //       type: "success"
          //     });
          //     sessionStorage.setItem("imgs",res.data.result.user.headurl)
          //     sessionStorage.setItem("id", res.data.result.user.id)
          //     sessionStorage.setItem("namess",res.data.result.user.nickname)
          //     sessionStorage.setItem("userAccount",res.data.result.user.userAccount)
          //     sessionStorage.setItem("isId",true)
          //     this.$router.go(0)
          //   } else {
          //     this.$message.error(res.data.msg)
          //     this.phone = ''
          //     this.Code = ''
          //   }
          // })
        }
      },
      passChange() {
        console.log(1111111);
        this.loginCode = '';
      },
      // 验证码登录
      SignInCode() {
        let data = {
          loginType: "verificationCode", //登录类型
          userAccount: this.phone, //手机号
          verificationCode: this.Code //验证码
        };
        console.log(data);
        let reg = /^1[3-9]{1}[0-9]{9}$/;
        if (!reg.test(this.phone)) {
          this.open4();
        } else if (this.phone == "" || this.Code == "") {
          this.open3();
        } else if(!this.rememberMe1) {
          this.open5();
        } else {
          this.axios
            .post("/consumer/login", data)
            .then(res => {
              console.log(res, "登录");  
            if(res.data.code == 'S200'){
              this.$message({
                  message: '登录成功',
                  type: 'success'
                });
                this.loginer = true
                this.$store.commit("LoginFun", false);
                sessionStorage.setItem("loginer",this.loginer)
                const id = res.data.result.user.id
                const imgs = res.data.result.user.headurl
                const namess = res.data.result.user.nickname
                sessionStorage.setItem("imgs",imgs)
                sessionStorage.setItem("id", id)
                sessionStorage.setItem("namess",namess)
                this.zcbh = 2
                sessionStorage.setItem("isId",true)
                this.$router.go(0)
            }else{
              this.$message.error(res.data.msg)
              this.ruleForm.code = ''
            }
          })
        }
      },
      // 验证码60秒倒计时
      validateBtn() {
        //倒计时
        let time = 60;
        let timer = setInterval(() => {
          if (time == 0) {
            clearInterval(timer);
            this.isDisable = false
            this.btnTitle = "发送验证码"
          } else {
            this.btnTitle = time + '秒后重试';
            time--
          }
        }, 1000)
      },
      open5() {
        this.noAgreeShow = true;
      },
      getCookie() {
        const phone = Cookies.get("phone");
        const Code = Cookies.get("Codes");
        const rememberMe1 = Cookies.get("rememberMe1");
        this.phone = this.phone === undefined ? this.phone : phone
        this.Code = this.Code === undefined ? this.Code : decrypt(Code)
        this.rememberMe1 = this.rememberMe1 === undefined ? false : Boolean(rememberMe1)
      },
      changeAgree(e) {
        if(e) {
          this.noAgreeShow = false;
        } else {
          this.noAgreeShow = true;
        }
      },
      open4() {
        this.$message.error("手机号输入有误");
      },
      open3() {
        this.$message.error("验证码不能为空");
      },
      open2() {
        this.$message.error("账号或密码不能为空");
      },
      open1() {
        this.$message.error("手机号或邮箱输入有误");
      },
      // 手机号失焦事件
      phoneFun() {
        let reg = /^1[3-9]{1}[0-9]{9}$/;
        let regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        // if (!reg.test(this.phone)) {
        //   this.open4();
        // }
        // if(!regEmail.test(this.phone)) {
        //   this.open5()
        // }
        if(!regEmail.test(this.phone) && !reg.test(this.phone)) {
          this.open1()
        }
      },
      phoneFun1(){
        let reg = /^1[3-9]{1}[0-9]{9}$/;
        if (!reg.test(this.phone)) {
          this.open4();
        }
      },
      //获取登录验证码
      obtainCode() {
        // let reg = /^1[3-9]{1}[0-9]{9}$/;
        // let regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        // if (!reg.test(this.phone) && !regEmail.test(this.phone)) {
        //   this.open1();
        // } else {
          if (!this.phone) {
            setTimeout(() => {
              this.phone = ''
            }, 2000)
          } else if (!/^1[345678]\d{9}$/.test(this.phone) && !
            /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.phone)) {
            setTimeout(() => {
              this.phone = ''
            }, 2000)
          } else {
            this.validateBtn();
          this.axios
            .get("/consumer/sendEmailCode?userAccount=" + this.phone)
            .then(res =>{
              this.isDisable = true
            this.$message("发送验证码成功")
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      },
      // 切换账号登录
      SwitchDeng() {
        this.phone = "";
        this.Code = "";
        this.Switch = !this.Switch;
      },
      tozfb(){
        this.zfblogin = !this.zfblogin;
      }
    },
    mounted() {
      // 绑定监听事件
      // window.addEventListener("keydown", this.keyDown);
    },
    destroyed() {
      // 销毁事件
      // window.removeEventListener("keydown", this.keyDown, false);
    },
  };
</script>
<!-- 声明语言，并且添加scoped -->
<style scoped>
.SwitchBox p span {
  color: rgb(139, 79, 69);
}
.SwitchBox p {
  cursor: pointer;
  font-size: .12rem;
  color: rgb(153, 153, 153);
}
.SwitchBox {
  justify-content: space-between;
  display: flex;
}
.dengLuBut button {
  cursor: pointer;
  width: 100%;
  height: .46rem;
  line-height: .46rem;
  background: #ee8e32;
  border-radius: .32rem;
  margin-top: .1rem;
  border: none;
  font-size: .18rem;
  color: rgb(255, 255, 255);
  margin-bottom: .26rem;
}
.radiusBox {
  border-radius: .32rem;
  border: .01rem solid rgba(199, 199, 199, 1);
  align-items: center;
  padding-left: .12rem;
  padding-right: .2rem;
}
.Code button {
  width: 1.2rem;
  height: .4rem;
  box-sizing: border-box;
  background: #fff;
  cursor: pointer;
  border: none;
  font-size: .14rem;
  color: #ff9137;
}
.Code input {
  margin-right: .08rem;
  background: #fff;
  width: 2.25rem;
  height: .4rem;
  font-size: .14rem;
  padding: 0 .12rem;
  box-sizing: border-box;
  border: none;
}
.phone input[type="text"]:focus,
.Code input[type="text"]:focus {
  outline: none;
  border-color: rgb(139, 79, 69);
  background-color: #fff !important;
}
.phone input[type="password"]:focus,
.Code input[type="password"]:focus {
  outline: none;
  border-color: rgb(139, 79, 69);
  background-color: #fff !important;
}
.phone input {
  width: 100%;
  height: .4rem;
  font-size: .14rem;
  padding: 0 .12rem;
  box-sizing: border-box;
  background: #fff !important;
  border: none;
}
input[type="text"]:hover,
input[type="text"]:focus {
  background-color: transparent !important;
  border-width: 0;
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-transition-delay: 99999s;
  -webkit-transition: color 99999s ease-out,
  background-color 99999s ease-out;
}
.phone {
  margin-bottom: .1rem;
}
.SignInBut p:nth-of-type(1) {
  margin-right: .6rem;
}
.SignInBut p {
  color: #000;
  font-size: .14rem;
  cursor: pointer;
}
.SignInBut .Highlight {
  border-bottom: .02rem solid #ee8e32;
}
.SignInBut {
  display: flex;
  line-height: .4rem;
  justify-content: center;
  margin-bottom: .4rem;
}
.close {
  position: absolute;
  top: 0px;
  right: .12rem;
  color: rgb(163, 163, 163);
  font-size: .3rem;
  padding: 0;
  margin: 0;
  cursor: pointer;
}
.rightBox {
  position: relative;
  flex: 1;
  padding: .2rem 0px;
  /* background: #fff; */
  /* border-radius: .12rem; */
}
.InterfaceBox {
  display: flex;
  width: 4.6rem;
  height: 3.95rem;
  background: #fff;
  /* padding: .08rem; */
  /* background: rgba(238,142,50, 0.5); */
  border-radius: .12rem;
  border: .01rem solid #666;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
}
.box {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
  z-index: 2999;
  background: rgba(0,0,0,0.6);
}

.zhi {
		width: 100%;
		height: .24rem;
		display: flex;
		justify-content: space-around;
		margin-top: .24rem;
	}
	
	.xian {
		width: .8rem;
		height: 0px;
		border: solid .01rem #d1d1d1;
		margin-top: .12rem;
	}
	
	.wordss {
		font-family: Microsoft YaHei;
		font-size: .14rem;
		font-weight: normal;
		font-stretch: normal;
		line-height: .24rem;
		letter-spacing: 0px;
		color: #a7a7a7;
	}
	
	.logins {
		width: 70%;
		height: 2rem;
		margin: auto;
		display: flex;
		margin-top: .64rem;
	}
	
	.logins-one {
		width: 50%;
		height: 80%;
		cursor: pointer;
	}
	
	.login-two {
		width: 50%;
		height: 100%;
		cursor: pointer;
	}
	
	.log-one-top {
		width: 1rem;
		height: 1rem;
		border-radius: 50%;
		margin: auto;
	}
	
	.log-one-button {
		font-family: Microsoft YaHei;
		font-size: .16rem;
		font-weight: normal;
		font-stretch: normal;
		line-height: .24rem;
		letter-spacing: 0px;
		color: #4e4e4e;
		text-align: center;
		margin-top: .15rem;
	}
  .redTip {
    position: absolute;
    bottom: -.2rem;
    left: .44rem;
    color: red;
    font-size: .12rem;
  }
  .login-code {
    width: 33%;
    height: .48rem;
    float: right;
    img {
      cursor: pointer;
      vertical-align: middle;
    }
  }
  .login-code-img {
    height: .38rem;
  }
</style>



// WEBPACK FOOTER //
// src/LoginRegist/login/index.vue